import { Checkbox, DataSource, ExcludableTextbox, Layout, Switch, Textbox } from "@mcleod/components";

export abstract class AutogenLayoutSettlementCheckReport extends Layout {
    checkboxManualChecks: Checkbox;
    checkboxSettlementChecks: Checkbox;
    excludabletextboxCheckNumbers: ExcludableTextbox;
    excludabletextboxGlAccounts: ExcludableTextbox;
    excludabletextboxPayees: ExcludableTextbox;
    sourceSettlementCheck: DataSource;
    switchSwitch1: Switch;
    textboxClearedStatus: Textbox;
    textboxDateRange: Textbox;
    textboxVoidedStatus: Textbox;
}
